import React from 'react';

const Product: React.FC = () => {
  return (
    <section id="product" className="section-padding bg-neutral-50">
      <div className="container-max">
        <div className="bg-white rounded-2xl p-8 md:p-12 border border-neutral-200">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
            <div className="max-w-xl">
              <p className="text-sm text-neutral-500 mb-3">Our product</p>
              <h3 className="sr-only">AwesomeHires</h3>
              <p className="text-neutral-600 leading-relaxed">
                Stop losing great candidates to a slow hiring process. AwesomeHires streamlines and
                accelerates your recruitment workflow so your team can identify, engage, and secure
                top talent before the competition does.
              </p>
            </div>

            <div className="flex flex-col items-start md:items-center gap-5 shrink-0">
              <img
                src="/images/awesomehires-logo.png"
                alt="AwesomeHires"
                className="h-16 md:h-20 w-auto"
              />
              <a
                href="https://awesomehires.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-black hover:bg-neutral-800 text-white text-sm font-medium px-6 py-3 rounded-full transition-colors whitespace-nowrap"
              >
                Visit AwesomeHires
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
